// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2sGJU","description":"PatientConsentPreview_description__2Sm4M"};